export default __webpack_public_path__ + "static/media/preview_vito.0d400ce7.webp";